import React, { FC } from 'react';

export interface ISpinnerProps {
  color?: string;
  size?: string | number;
  className?: string;
}

const Spinner: FC<ISpinnerProps> = ({
  size = '30px',
  color = '#80A6B5',
  className = '',
  ...props
}) => {
  const sizeNum = typeof size === 'string' ? parseInt(size) : size;

  return (
    <svg
      className={`animate-spin ${className}`}
      height={sizeNum}
      viewBox="0 0 50 50"
      width={sizeNum}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        className="opacity-20"
        cx="25"
        cy="25"
        fill="none"
        r="20"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="5"
      />
      <circle
        cx="25"
        cy="25"
        fill="none"
        r="20"
        stroke={color}
        strokeDasharray="80"
        strokeDashoffset="60"
        strokeLinecap="round"
        strokeWidth="5"
      />
    </svg>
  );
};

export default Spinner;
